import { SVG, SVGProps } from './svg'

export function IconFullscreen(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M3 8.5V5c0-1.1.9-2 2-2h3.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H5v3.5c0 .3-.2.5-.5.5h-1a.5.5 0 01-.5-.5zM15.5 3H19a2 2 0 012 2v3.5c0 .3-.2.5-.5.5h-1a.5.5 0 01-.5-.5V5h-3.5a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5zM19 15.5V19h-3.5c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5H19a2 2 0 002-2v-3.5c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5zM3.5 15h1c.3 0 .5.2.5.5V19h3.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H5a2 2 0 01-2-2v-3.5c0-.3.2-.5.5-.5z" />
    </SVG>
  )
}
